<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>A Year of Biblical Womanhood</title><link href="default.css" rel="stylesheet" type="text/css"/>
<p class="txcm11" id="p0012-01-0" style="margin-top: 25%;"><span><i>Consider the lilies—is the only commandment I ever obeyed.</i></span></p>
<p class="txcm11m" id="p0012-02-1"><span>—E<span class="small">MILY</span> D<span class="small">ICKINSON</span></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter4.vue?5f731852